/**
 * Theme-aligned palette for MUI X Charts (bars, lines, pie).
 */
export function buildChartPalette(theme) {
  if (!theme?.palette) {
    return ['#008d4d', '#1976d2', '#00a884', '#9c27b0', '#ed6c02', '#0288d1', '#3f51b5', '#00897b', '#f59e0b'];
  }

  const { palette } = theme;
  const chat = palette.chat || {};

  const candidates = [
    chat.primary,
    palette.primary?.main,
    '#008d4d',
    '#1976d2',
    '#00a884',
    '#9c27b0',
    '#ed6c02',
    '#0288d1',
    '#3f51b5',
    '#00897b',
    '#f59e0b',
    '#7b1fa2',
    '#2e7d32',
    '#0097a7',
    '#4f46e5',
    '#06b6d4',
  ];

  const RED_PATTERN = /^(#e53935|#d32f2f|#f44336|#ef4444|#dc2626|#b71c1c|#c62828|red)$/i;
  const seen = new Set();
  const colors = [];
  candidates.forEach((color) => {
    const normalized = String(color || '').trim();
    if (!normalized || seen.has(normalized) || RED_PATTERN.test(normalized)) return;
    seen.add(normalized);
    colors.push(normalized);
  });

  return colors.length ? colors : ['#008d4d', '#1976d2', '#00a884', '#9c27b0', '#ed6c02', '#0288d1', '#3f51b5', '#00897b', '#f59e0b'];
}

export function resolveSeriesColor(palette, index = 0, explicit) {
  if (explicit) return explicit;
  if (!palette?.length) return undefined;
  return palette[index % palette.length];
}

export function chartAxisColors(theme) {
  const text = theme?.palette?.text?.secondary || '#64748b';
  const grid = theme?.palette?.divider || 'rgba(0,0,0,0.08)';
  return { text, grid };
}
